import React, { useEffect, useState } from "react";
import {
  Box,
  SpanStyled,
  ThemeLoader,
} from "../../../../components/styled/Elements";
import {
  tempPermissionsCols,
} from "../../../../helpers/adminConstants/TableConstants";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Table } from "react-bootstrap";
import { CustomCheckbox } from "../../../../components/styled/FormElements";
import UsersApi from "../../../../services/api/usersApi";

const TempUserPermissions = ({ permissions, setPermissions, watch }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [sharedCabinets, setSharedCabinets] = useState([]);

  const handleChange = (cabinetId, permissionId, isChecked) => {
    setPermissions((prev) => {
      const currentPermissions = prev[cabinetId] || [];

      let updatedPermissions;
      if (isChecked) {
        updatedPermissions = [
          ...new Set([...currentPermissions, permissionId]),
        ];
      } else {
        updatedPermissions = currentPermissions.filter(
          (id) => id !== permissionId
        );
      }

      return {
        ...prev,
        [cabinetId]: updatedPermissions.length ? updatedPermissions : undefined,
      };
    });
  };

  const getSharedCabinets = async () => {
    try {
      setLoading(true)
      const { code, data } = await UsersApi.getSharedCabinets();
      if (code === 200) {
        const updatedData = data?.data?.map((cabinet) => ({
          id: cabinet?.id,
          module_name: cabinet?.name,
          view: 1,
          view_open: 2,
        }));
        setSharedCabinets(updatedData);
      }
    } catch (err) {
      console.error("Failed to fetch shared cabinets", err);
    }finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getSharedCabinets();
  }, []);
  

  return (
    <Box className="overflow-x-auto">
      <StyledTable>
        {loading ? (
          <ThemeLoader />
        ) : (
          <>
            <thead>
              <tr>
               
                {tempPermissionsCols?.map((operation) => (
                  <th key={operation.id}>
                    <SpanStyled size="16px" color="var(--text)" weight="bold">
                      {t(operation.title)}
                    </SpanStyled>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sharedCabinets?.map((cabinet) => (
                <tr key={cabinet?.id}>
                  <td>
                    <SpanStyled size="16px" color="var(--text2)">
                      {t(cabinet?.module_name)}
                    </SpanStyled>
                  </td>
                  {/* <td>
                    <Box className="d-flex justify-content-center">
                      <CustomCheckbox
                        name={cabinet?.id.toString()}
                        checked={(permissions?.[cabinet?.id] || [])?.includes(
                          1
                        )}
                        onChange={(e) =>
                          handleChange(cabinet?.id, 1, e.target.checked)
                        }
                      />
                    </Box>
                  </td> */}

                  <td>
                    <Box className="d-flex justify-content-center">
                      <CustomCheckbox
                        name={cabinet?.id.toString()}
                        checked={(permissions?.[cabinet?.id] || [])?.includes(
                          2
                        )}
                        onChange={(e) =>
                          handleChange(cabinet?.id, 2, e.target.checked)
                        }
                      />
                    </Box>
                  </td>
                </tr>
              ))}
            </tbody>
          </>
        )}
      </StyledTable>
    </Box>
  );
};

export default TempUserPermissions;

// Styled table to match your custom styling
export const StyledTable = styled(Table)`
  border-bottom: 1px solid var(--borderLight);
  margin-bottom: 0;
  thead tr {
    border-bottom: 1px solid var(--borderLight);
  }
  th,
  td {
    text-align: center;
    vertical-align: middle;
    padding: 2rem 16px;
    border: none;
  }

  th {
    font-size: 16px;
    font-weight: 500;
    color: var(--text);
  }

  td {
    font-size: 14px;
  }

  th.title-column {
    width: 160px;
  }
`;
